import { Dropdown as AntDropdown, Col, Form } from 'antd';
import type { IField } from '../data';
import styles from '../styles.less';

const { Item } = Form;

const Dropdown: React.FC<IField> = (props) => {
    const { name, span = 8, label, placeholder, xs, lg, marginBottom = 0, menu, t } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item name={name} label={t?.(label)} className={styles.fullDropdown} {...styling}>
                <AntDropdown.Button menu={menu} className={styles.fullWidth}>
                    <div className={styles.fullWidth}>{t?.(placeholder)}</div>
                </AntDropdown.Button>
            </Item>
        </Col>
    );
};

export default Dropdown;
